export default "__VITE_ASSET__cC4gYL3f__"